function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to get private field on non-instance"); } if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to set private field on non-instance"); } if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } return value; }

import { Swatch } from "./color.js";
import { MMCQ } from "./quantizer/index.js";
import { Generator } from "./generator.js";
import { defaultFilter, combineFilters } from "./filter.js";
import { NodeImage } from "./image.js";

var _src = new WeakMap();

var _process = new WeakMap();

export class Vibrant {
  get opts() {
    return {
      colorCount: this.colorCount,
      quality: this.quality,
      maxDimension: this.maxDimension,
      filters: this.filters,
      combinedFilter: this.combinedFilter
    };
  }

  constructor(src, opts = {}) {
    _src.set(this, {
      writable: true,
      value: void 0
    });

    _defineProperty(this, "colorCount", 64);

    _defineProperty(this, "quality", 5);

    _defineProperty(this, "maxDimension", void 0);

    _defineProperty(this, "filters", [defaultFilter]);

    _defineProperty(this, "combinedFilter", void 0);

    _defineProperty(this, "ImageClass", NodeImage);

    _defineProperty(this, "quantizer", MMCQ);

    _defineProperty(this, "generator", Generator);

    _process.set(this, {
      writable: true,
      value: image => {
        const imageData = image.applyFilter(this.combinedFilter);
        const colors = this.quantizer(imageData, {
          colorCount: this.colorCount
        });
        const filtered = Swatch.applyFilter(colors, this.combinedFilter);
        return this.generator(filtered);
      }
    });

    _classPrivateFieldSet(this, _src, new URL(src));

    Object.assign(this, opts);
    this.combinedFilter = combineFilters(this.filters);
  }

  async getPalette() {
    const image = new this.ImageClass(_classPrivateFieldGet(this, _src));
    const result = await image.load();

    const palette = _classPrivateFieldGet(this, _process).call(this, result);

    image.remove();
    return palette;
  }

}